ck = ck || {};
ck.formValidator = (function () {
  let _private = {};
  let _public = {};
  _private.formCheck = {};
  _private.formGroups = {};

  _private.validateEmail = function (item) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(item.value);
  };

  _private.validateMatchOther = function (item) {
    let otherSelector = $(item).data('related-field-selector');
    let otherValue = $(otherSelector)[0].value;
    return (item.value.length > 0 && item.value === otherValue);
  };

  _private.validateIntegerRequired = function (item) {
    return parseInt(item.value) > 0;
  };

  _private.validateAtLeastOne = function (item, $formElements) {
    let groupid = $(item).data('group-id');

    //if group is already valid just return true
    if (_private.formGroups[groupid]) {
      return true;
    }

    //if this is checked, set all in group to validated
    if ($(item).is(':checked')) {
      _private.formGroups[groupid] = true;
      $formElements.each(function (elIndex, el) {
        if ($(el).data('group-id') === groupid) {
          _private.formCheck[elIndex] = true;
        }
      });
    }
    return _private.formGroups[groupid];
  };

  _public.validate = function (inputForm) {
    let $formElements = $(inputForm).find('input,select');
    _private.formGroups = {};
    _private.formCheck = {};

    $formElements.each(function (elIndex, el) {
      let fieldType = $(el).data('form-field-type');
      switch (fieldType) {
        case 'email':
          _private.formCheck[elIndex] = _private.validateEmail(el);
          break;
        case 'match-other':
          _private.formCheck[elIndex] = _private.validateMatchOther(el);
          break;
        case 'integer-required':
          _private.formCheck[elIndex] = _private.validateIntegerRequired(el);
          break;
        case 'at-least-one':
          _private.formCheck[elIndex] = _private.validateAtLeastOne(el, $formElements);
          break;
      }
    });
    $('.restockForm .alert-warning').removeClass('alert-warning');
    $('.restockForm .hasErrors').removeClass('hasErrors');
    let formIsValid = true;
    for (elIndex in _private.formCheck) {
      if (!_private.formCheck[elIndex]) {
        formIsValid = false;
        $($formElements[elIndex]).addClass('alert-warning').parent().addClass('hasErrors');
      }
    }

    return formIsValid;
  };

  return _public;
}());
